import React from "react";
import { AppBar, Toolbar, Typography, Avatar, Stack, Button } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import logo from "../../images/logo.svg";

export default function Banner({ handleLogOut }) {
  return (
    <AppBar position="static" sx={{ bgcolor: "primary.main", boxShadow: "none" }}>
      <Toolbar sx={{ justifyContent: "space-between", px: { xs: 1, md: 3 }, py: 3 }}>
        <img src={logo} alt="Pearson Logo" style={{ height: "24px" }} />
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: "primary.contrastText", color: "primary.main", width: 48, height: 48 }}>
            <PersonIcon sx={{ fontSize: 32 }} />
          </Avatar>
          <Typography variant="h6" sx={{ color: "primary.contrastText", fontSize: "18px" }}>
            John Doe
          </Typography>
          <Button
            variant="outlined"
            sx={{
              color: "primary.contrastText",
              borderColor: "primary.contrastText",
              textTransform: "none",
            }}
            onClick={handleLogOut}
          >
            Logout
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}